export const environment = {
  name: 'staging',
  production: false,
  api: {
    origin: 'https://sunbrickapi.azurewebsites.net',
    basePath: '/api/v1',
  },
  codeFormat: {
    mask: 'ZZZ-9999',
  },
  auth: {
    debugSessionLogging: false,
    storageKey: 'sunbrickerp.auth',
    tokenStorageKey: 'sunbrickerp.auth.token',
    entra: {
      tenantId: '23c53873-fbe9-46de-b74f-14dfb6f9689e',
      authority: 'https://login.microsoftonline.com/23c53873-fbe9-46de-b74f-14dfb6f9689e',
      clientId: '64af7e49-7988-48a3-b933-eb71fac69b64',
      demoLoginHint: 'demo@raygozajcyahoo.onmicrosoft.com',
      scopes: [
        'api://93bbd0e6-49ac-4f65-bb5c-3d9a0224fd1b/reports.read',
        'api://93bbd0e6-49ac-4f65-bb5c-3d9a0224fd1b/reports.write',
        'api://93bbd0e6-49ac-4f65-bb5c-3d9a0224fd1b/products.read',
        'api://93bbd0e6-49ac-4f65-bb5c-3d9a0224fd1b/products.write',
        'api://93bbd0e6-49ac-4f65-bb5c-3d9a0224fd1b/inventory.read',
        'api://93bbd0e6-49ac-4f65-bb5c-3d9a0224fd1b/inventory.write',
        'api://93bbd0e6-49ac-4f65-bb5c-3d9a0224fd1b/movements.read',
        'api://93bbd0e6-49ac-4f65-bb5c-3d9a0224fd1b/movements.write',
        'api://93bbd0e6-49ac-4f65-bb5c-3d9a0224fd1b/warehouses.read',
        'api://93bbd0e6-49ac-4f65-bb5c-3d9a0224fd1b/warehouses.write',
        'api://93bbd0e6-49ac-4f65-bb5c-3d9a0224fd1b/categories.read',
        'api://93bbd0e6-49ac-4f65-bb5c-3d9a0224fd1b/categories.write',
        'api://93bbd0e6-49ac-4f65-bb5c-3d9a0224fd1b/units.read',
        'api://93bbd0e6-49ac-4f65-bb5c-3d9a0224fd1b/units.write',
        'api://93bbd0e6-49ac-4f65-bb5c-3d9a0224fd1b/packagingtypes.read',
        'api://93bbd0e6-49ac-4f65-bb5c-3d9a0224fd1b/packagingtypes.write',
        'api://93bbd0e6-49ac-4f65-bb5c-3d9a0224fd1b/movementtypes.read',
        'api://93bbd0e6-49ac-4f65-bb5c-3d9a0224fd1b/movementtypes.write',
        'api://93bbd0e6-49ac-4f65-bb5c-3d9a0224fd1b/customertypes.read',
        'api://93bbd0e6-49ac-4f65-bb5c-3d9a0224fd1b/customertypes.write',
        'api://93bbd0e6-49ac-4f65-bb5c-3d9a0224fd1b/providers.read',
        'api://93bbd0e6-49ac-4f65-bb5c-3d9a0224fd1b/providers.write',
        'api://93bbd0e6-49ac-4f65-bb5c-3d9a0224fd1b/clients.read',
        'api://93bbd0e6-49ac-4f65-bb5c-3d9a0224fd1b/clients.write',
        'api://93bbd0e6-49ac-4f65-bb5c-3d9a0224fd1b/exchange-rates.read',
        'api://93bbd0e6-49ac-4f65-bb5c-3d9a0224fd1b/exchange-rates.write',
      ],
      redirectPath: '/login',
    },
  },
} as const;
